import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
var ConfirmationModal = function ConfirmationModal(_ref) {
  var editMode = _ref.editMode,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: editMode ? t('actions_quit_editing_section') : t('actions_quit_creating_section'),
    body: editMode ? t('modal_confirm_quit_edit_without_save') : t('modal_confirm_quit_creation_without_save'),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel
    }, {
      label: t('actions_confirm'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onCancel
  });
};
export default ConfirmationModal;